export default __webpack_public_path__ + "static/media/3dots.eb49b0dc.svg";